import React, { useState, useEffect, useRef, useCallback, useMemo } from "react";
import { SlDrawer, SlButton, SlInput, SlIcon, SlOption, SlSelect,SlDialog } from '@shoelace-style/shoelace/dist/react';
import AsyncSelect from 'react-select/async';
import { useNavigate } from "react-router";
import * as Yup from "yup";
import { Toast } from "../../shared/Toast";
import api from "../../services/api";
import { formatDate, formatDateYYYYMMDD } from "../../utils/dateFormat";
import NoDataFound from "../../shared/NoDataFound";
import TableLoader from "../../shared/TableLoader";
import { roles, langoptions, NewspaperDistrictEditonAdformats, NewspaperMainEditonAdformats, BirdviewStates } from "../../utils/constants";
import { useDispatch, useSelector } from 'react-redux';
import * as XLSX from 'xlsx';
import { useForm, Controller } from 'react-hook-form';
import { toast } from "react-toastify";
import Button from 'react-bootstrap/Button';
import Datepicker from "react-tailwindcss-datepicker";
import { CSVLink } from "react-csv";
import NoImage from "../../assets/images/NoImage.png";
import EditIcon from "../../assets/images/edit_icon.svg";
import UserIcon from "../../assets/images/user_icon.svg";
import { newspaperLangs } from "../../utils/constants";
import LocationSVG from "../../assets/images/location.svg";
import Select  from 'react-select'
import { Modal } from "react-bootstrap";
import filterSvg from '../../assets/images/filter.svg';
import { SlProgressBar } from '@shoelace-style/shoelace/dist/react';
import { debounce, debouncePromise } from "../../utils/Debounce";
import BirdviewSummary from "./BirdviewSummary";
import ReportBirdview from "../SalesPanel/ReportBirdview";
const BirdviewSchema = Yup.object().shape({
    page_no: Yup.number().required("Please enter page number"),
    page_name: Yup.string().required("Please enter Page Name"),
    ad_format: Yup.string().required("Please enter Ad format"),
    edition: Yup.string().required("Please enter edition"),
    location: Yup.string().nullable(),
    newspaper_name: Yup.string().matches(/^[a-zA-Z][a-zA-Z\s._]*$/, "Newspaper Name must have only alphabets").required("Please enter Newspaper Name"),
    date: Yup.date().required("Please select the date"),
    image_url: Yup.string().optional().nullable(),
    estimated_value: Yup.string().required("Please enter estimated price"), 
    language: Yup.string().required("Please enter Language"),
    campaign_name: Yup.string().required("Please enter Campaign Name"),
    brand_name: Yup.number().required("Please enter brand Name")
});

function Birdview() {
    let today = new Date(), yesterday = new Date()
    yesterday.setDate(today.getDate() - 1)
    yesterday.setHours(0,0,0,0)

    const navigate = useNavigate();
    const fileInputRef = useRef(null);
    const [flag, setFlag] = useState("");
    const [show, setShow] = useState(false);
    const [submit, setSubmit] = useState(false);
    const [currentPage, setCurrentPage] = useState(0);
    const [search, setSearch] = useState("");
    const [loader, setLoader] = useState(false);
    const [data, setData] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const BirdViewDate = useSelector((state) => state.Head.birdviewDate)
    const [advertiserFields, setAdvertiserFields] = useState([{ adv_name: "" }])
    const [sources, setSources] = useState([])
    const [id, setId] = useState("");
    const [advDetails, setAdvDetails] = useState();
    const [image, setImage] = useState("")
    const [preview, setPreview] = useState(false);
    const [del, setDel] = useState(false);
    const [dateRange, setDateRange] = useState({ startDate: yesterday.toLocaleDateString('sv-SE')?.split('T')[0], endDate: today.toLocaleDateString('sv-SE')?.split('T')[0] });
    const [downloadData, setDownloadData] = useState([]);
    const [downloadLoader, setDownloadLoader] = useState(false)
    const [clickindex, setClickIndex] = useState(-1);
    const [open, setOpen] = useState(false);
    const [totalRecords, setTotalRecords] = useState(0);
    const [adType, setAdType] = useState("Finite");
    const [selectedBrandType, setSelectedBrandType] = useState('0');
    const [newspapers, setNewspapers] = useState([]);
    const [estimatedValue, setEstimatedValue] = useState(0)
    const [locations, setLocations] = useState([]);
    const [newspaperLocations, setNewspaperLocations] = useState([]);
    const [selectedNewspaper, setSelectedNewspaper] = useState([]);
    const [selectedLocation, setSelectedLocation] = useState([]);
    const [userType, setUserType] = useState("");
    const [imgSrc, setImgSrc] = useState("");
    const [fileUrl, setFileUrl] = useState("")
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [unknownBrands, setUnknownBrands] = useState([])
    const [showunknown, setShowUnknown] = useState(false)
    const [selectedBrands, setSlectedBrands] = useState([])
    const [completedBrands, setCompletedBrands] = useState([])
    const [mainBrand, setMainBrand] = useState([]);
    const [choosedBrand, setChoosedBrand] = useState();
    const [merge, setMerge] = useState(false)
    const [showFilter, setShowFilter] = useState(false)
    // const [merge, setMerge] = useState(false);
    const [brands, setBrands] = useState([]);
    const [progress, setProgress] = useState(0);
    const [imgUrl, setImgUrl] = useState("");
    const [uploadImage, setUploadImage] = useState("")
    const [date, setDate] = useState('');
    const [recentInsertedBirdview, setRecentInsertedBirdview] = useState();
    const [editions, setEditions] = useState([])
    const [newLocation, setNewLocation] = useState('');
    const [newLocationErr, setNewLocationErr] = useState('');
    const [newLocationState, setNewLocationState] = useState('');
    const [newLocationStateErr, setNewLocationStateErr] = useState('');
    const [brandType, setBrandType] = useState('finite');
    const [fileName, setFileName] = useState('');
    const observer = useRef();
    const [infLoader, setInfLoader] = useState(false);
    const [newspaperData, setNewsPaperData] = useState([]);
    const csvLinkRef = useRef(); // Create a ref for CSVLink
    const [newspaperLocationsObject, setNewspaperLocationsObject] = useState([]);
    const [showDialog,setShowDialog] = useState(null)
    const [selectedCategory, setSelectedCategory] = useState([]);
    const [newspaper_categories, setNewspaper_categories] = useState([]);
    const [initialRender, setInitialRender] = useState(true);
    const [showMagnifier, setShowMagnifier] = useState(false);
    const [position, setPosition] = useState({ x: 50, y: 50 });
    const [showSummary,setShowSummary] = useState(false)
    const [showReport, setShowReport] = useState(false)
    const [reportId, setReportId] = useState(0)
    const [reportImageUrl, setReportImageUrl] = useState()
    const imgRef = useRef(null);
    
    const zoomLevel = 5;
  
    const handleMouseMove = (e) => {
      const elem = imgRef.current;
      if (!elem) return;
  
      const { top, left, width, height } = elem.getBoundingClientRect();
      const x = ((e.pageX - left - window.pageXOffset) / width) * 100;
      const y = ((e.pageY - top - window.pageYOffset) / height) * 100;
  
      // Allow zooming even beyond edges (0-100% can become negative or >100%)
      setPosition({ x, y });
    };
    
    let defaultFirstBirdView = {
    lang_id: -1,
    edition: "",
    ad_format: "",
    newspaper_name: ""
   }

    const [firstBirdView,setfirstBirdView]=useState(defaultFirstBirdView);

    useEffect(() => {
        const getNewsPaperCategories = async () => {
            try {
                const res = await api({
                    url: `/birdview/newspapers_categories`,
                    method: "POST",
                    responseType: "json",
                });
    
                const categories = res?.data?.result || [];
                setNewspaper_categories([...categories]);
            } catch (error) {
                console.error("Failed to fetch newspaper categories:", error);
            }
        };
    
        getNewsPaperCategories();
    }, []);
    
    const { handleSubmit, register, control, formState: { errors,isSubmitting }, setValue, watch, getValues, reset } = useForm();

    const watchEdition = watch('edition');
    const watchLanguage = watch('language');
    const watchAdFormat = watch('ad_format');
    const watchNewspaperName = watch('newspaper_name');
    const watchBrandType = watch('brand_type')
    const watchLocation = watch("location");

    const locationObject = useMemo(() => {
        const obj = {};
        newspaperLocationsObject.forEach((location) => {
            obj[location.value] = location.label;
        });
        return obj;})
    const getLocations = (locations) => {
    
        if (!locations) return '';
    
        // Wrap in array if it's not already one
        if (!Array.isArray(locations)) {
            locations = [locations];
        }
    
        const location_names = [];
    
        for (const location of locations) {
            const name = locationObject[+location]; // + converts to number
            if (name) location_names.push(name);
        }
    
        return location_names.length > 0 ? location_names.join(', ') : '';
    };
    
    const onSubmit = async (data) => {
        const locations = (
            data?.edition?.value?.includes('district') || data?.edition?.value?.includes('District')
          )
            ? data?.location?.map(loc => loc?.value)
            : [];
          
        if (flag === "add") {
            try {
                let res = await api({
                    url: `/birdview/add`,
                    method: "POST",
                    responseType: "json",
                    data: {
                        ad_format: data?.ad_format?.label,
                        brand_name: data?.brand_name,
                        brand_type: data?.brand_type?.value,
                        campaign_name: data?.campaign_name,
                        date: data?.date,
                        edition: data?.edition?.value,
                        estimated_value: data.estimated_value,
                        language: data?.language?.value,
                        newspaper_name: data?.newspaper_name?.value,
                        page_no: data?.page_no,
                        location: locations,
                        upload_url: imgUrl
                    },
                });
                if (res?.code !== 200) {
                    Toast('error', res?.data?.message);
                } else {
                    handleClose();
                    reset();
                    setCurrentPage(0);
                    setSearch("");
                    setFlag('');
                    loadData(search, 0, selectedLocation, dateRange, adType, selectedNewspaper, userType);
                    loadSources();
                    loadNewspapers(watchLanguage?.value);
                    resetAdvertiserFields();
                    setImgUrl("");
                    setUploadImage("");
                    setNewLocation('');
                    setIsModalOpen(false);
                    setNewLocationState('');
                    setShow(false);
                    Toast("success", "Birdview Added Successfully");
                }
            } catch (error) {
                Toast("error", "Something went Wrong")
            }
        }
        if (flag === "edit") {
            try {
                let res = await api({
                    url: `/birdview/edit`,
                    method: "PUT",
                    responseType: "json",
                    data: {
                        ad_format: data?.ad_format?.label,
                        brand_name: data?.brand_name,
                        brand_type: data?.brand_type?.value,
                        campaign_name: data?.campaign_name,
                        date: data?.date,
                        edition: data?.edition?.value,
                        estimated_value: data.estimated_value,
                        language: data?.language?.value,
                        newspaper_name: data?.newspaper_name?.value,
                        page_no: data?.page_no,
                        location: locations,
                        upload_url: imgUrl,
                        id: id

                    },
                });
                if (res?.code !== 200) {
                    Toast('error', res?.data?.message);
                } else {
                    reset()
                    resetAdvertiserFields();
                    handleClose();
                    setFlag('');
                    setCurrentPage(0);
                    loadData(search, 0, selectedLocation, dateRange, adType, selectedNewspaper, userType);
                    loadSources();
                    loadNewspapers(watchLanguage.value);
                    setImgUrl("")
                    setNewLocation('');
                    setNewLocationState('');
                    setIsModalOpen(false)
                    setfirstBirdView(defaultFirstBirdView);
                    Toast("success", "Birdview Edited Successfully");
                    setShow(false);
                }

            } catch (error) {
                Toast("error", "Something went wrong")
                if (error.response.status === 401)
                    navigate("/")
            }
        }
    };

    const handleDateRange = (selectedDate) => {
        setData([]);
        setCurrentPage(0)
        if (selectedDate) {
            if (selectedDate.startDate && selectedDate.endDate) {
                setDateRange(selectedDate);
            } else {
                setDateRange({ startDate: null, endDate: null });
            }
        } else {
            setDateRange({ startDate: null, endDate: null });
        }
    }

    function handleRequestClose(event) {
        if (event.detail.source === 'overlay') {
            event.preventDefault();
        }
    }

    const resetAdvertiserFields = () => {
        setAdvertiserFields([
            {
                adv_name: ""
            }
        ]);
    };

    const advData = async (id) => {
        if (localStorage.getItem("role") === roles.b2b || localStorage.getItem("role") === roles.salesperson) {
            // setLoader(true);
            let response = await api({
                url: `/birdview/advDetails`,
                method: "POST",
                responseType: "json",
                data: {
                    id: id
                }
            })
            if (response?.code !== 200) {
                toast.error(response?.data?.message);
                loadData(search, 0, selectedLocation, dateRange, adType, selectedNewspaper, userType);
            } else {
                setAdvDetails(response?.data?.result)
                setPreview(!preview);
                // setLoader(false);
            }
        }

    }

    const getBrands = async (brandType, edition) => {
        if (localStorage.getItem("role") === roles.b2b || localStorage.getItem("role") === roles.salesperson) {
            let response = await api({
                url: `/birdview/birdview_brands`,
                method: "POST",
                responseType: "json",
                data: {
                    brand_type: brandType,
                    edition: edition,
                }
            })
            if (response?.code !== 200) {
                toast.error(response?.data?.message);
            } else {
                setBrands(response?.data?.result)
            }
        }

    }

    const pageNameLower = watchEdition?.value ? watchEdition?.value.toLowerCase() : '';
    const isMain = pageNameLower.includes('main');
    const isDistrict = pageNameLower.includes('district');
    const AdFormatOptions = isMain ? NewspaperMainEditonAdformats : (isDistrict ? NewspaperDistrictEditonAdformats : NewspaperMainEditonAdformats);

    const handleClose = () => {
        reset();
        reset({
            brand_name: '',
            editon: '',
            ad_format: ''
        });
        setShow(false);
        setSubmit(false);
        setImgUrl("");
        setUploadImage("");
        clearFileInput();
        setIsModalOpen(false);
        setNewLocation('');
        setNewLocationState('');
        setNewLocationErr('');
        setNewLocationStateErr('');
        setBrandType('finite')
        setEstimatedValue(0);
        setId("");
        setFileName('')
        setfirstBirdView(defaultFirstBirdView);
    };
    const handleShow = async (choose, item) => {
        if (choose === "add") {
            setValue('date', date);
            setValue('page_no', recentInsertedBirdview?.page_no);
            setValue('ad_format', AdFormatOptions.find(option => option.label === recentInsertedBirdview?.ad_format));
            setValue('newspaper_name', newspapers.find(option => option.value === recentInsertedBirdview?.newspaper_name));
            setValue('language', langoptions.find(option => option.value === recentInsertedBirdview?.language));
            setValue('edition', editions.find(option => option.label === recentInsertedBirdview?.edition));
            setValue('location', newspaperLocations?.find(option => option.value === recentInsertedBirdview?.location));
            setValue('brand_name', recentInsertedBirdview?.brand_id)
            setValue('brand_type', recentInsertedBirdview?.ad_type === 'Finite' ? 'finite' : recentInsertedBirdview?.ad_type === 'Infinite' ? 'infinite' : "")
            setAdvertiserFields([{ adv_name: "" }])
            setShow(true);
            setBrands([{label:recentInsertedBirdview?.brand_name,value:recentInsertedBirdview?.brand_id}])

        }
        if (choose === "edit") {
            setValue('date', formatDateYYYYMMDD(item?.date));
            setValue('language', langoptions.find(option => option.value === item?.language));
            setValue('newspaper_name', newspapers.find(option => option.value === item?.newspaper_name));
            setValue('page_no', item.page_no);
            setValue('edition', editions.find(option => option.value === item?.edition));
            setValue('location', item.location? item.location?.map(location => newspaperLocations?.find(option => option.value === location)) : []);
            setValue('ad_format', AdFormatOptions.find(option => option.label === item?.ad_format));
            setValue('estimated_value', item.estimated_value);
            setValue('campaign_name', item.campaign_name);
            setValue('brand_name', item?.brand_id)
            setValue('brand_type', item?.ad_type === 'Finite' ? 'finite' : item?.ad_type === 'Infinite' ? 'infinite' : "")
            setAdvertiserFields(item?.advertisers);
            setImgUrl(item?.image_url)
            setShow(true);
            setEstimatedValue(item?.estimated_value);
            setInitialRender(false);
            setBrands([{ label: item.brand_name, value: item.brand_id }]);

        }
    };

    const loadSources = async () => {
        if (localStorage.getItem("role") === roles.b2b || localStorage.getItem("role") === roles.salesperson) {
            // setLoader(true);
            const response = await api({
                url: `/birdview/sources`,
                method: "POST",
                responseType: "json",
                data: { adType: adType }
            });
            if (response?.code === 200) {
                setSources(response?.data?.result);
                // setLoader(false);
            }  else if(response?.data?.code !== 401) { 
                toast.error(response?.data?.message);
                // setLoader(false)
            }

        }
    };

    const loadNewspapers = async (language) => {
        if (localStorage.getItem("role") === roles.b2b || localStorage.getItem("role") === roles.salesperson) {
            const response = await api({
                url: `/birdview/newspaper_names`,
                method: "POST",
                responseType: "json",
                data: { lang_id: language }
            });
            if (response?.code === 200) {
                setNewspapers(response?.data?.result);
            } else if(response?.data?.code !== 401) {
                toast.error(response?.data?.message)
            }
        }
    };

    const fetchNewsPapers = async () => {
        try {
            let res = await api({
                url: "/market/newspapers",
                method: "POST",
                responseType: "json",
                data: {},
            });
            if (res.code === 200) {
                setNewsPaperData([...res.data]);
            }
        } catch (error) {
            console.error(error);
        }
    };

    const loadLocations = async () => {
        // if ((localStorage.getItem("role") === roles.b2b || localStorage.getItem("role") === roles.salesperson) && adType === "District") {
        if (localStorage.getItem("role") === roles.b2b || localStorage.getItem("role") === roles.salesperson) {
            const response = await api({
                // url: `/birdview/birdviewLocations`,
                url: `/birdview/brandsLocations`,
                method: "POST",
                responseType: "json",
            });
            if (response?.code === 200) {
                setLocations([...response?.data?.result]);
            }  else if(response?.code !== 401) {
                toast.error(response?.data?.message)
            }
        }
    };

    const loadNewspaperLocations = async (language, edition) => {
        if (localStorage.getItem("role") === roles.b2b || localStorage.getItem("role") === roles.salesperson) {
            const response = await api({
                url: `/birdview/newspaper_locations`,
                method: "POST",
                responseType: "json",
                data: { lang_id: language, edition: edition }
            });
            if (response?.code === 200) {
                setNewspaperLocations(response?.data?.result);
                if(newspaperLocationsObject.length === 0){
                    setNewspaperLocationsObject(response?.data?.result)
                }
            }  else if(response?.data?.code !== 401) {
                toast.error(response?.data?.message)
            }
        }
    };

    const loadData = async (search = "", page = 0, selectedLocation, dateRange, adType, selectedNewspaper, userType) => {
        if (localStorage.getItem("role") === roles.b2b || localStorage.getItem("role") === roles.salesperson) {
            try {
                if (data?.length === 0) {
                    setLoader(true);
                }
                const response = await api({
                    url: `/birdview/get`,
                    method: "POST",
                    responseType: "json",
                    data: {
                        BirdViewSearch: search,
                        page,
                        BirdViewSource: selectedLocation.length ? selectedLocation?.map(item => item.value) : [],
                        dateRange,
                        category_ids:selectedCategory.map((cat) => cat.value),
                        adType,
                        selectedNewspaper: selectedNewspaper.length ? selectedNewspaper.map(item => item.value) : [],
                        selectedBrandType: +selectedBrandType,
                        userType,
                        limit: 20
                    },
                });
    
                if (response?.code === 200) {

                    if(infLoader){
                        setData(prevData => [...prevData, ...response?.data?.result?.res]);
                    } else {
                        setData(response?.data?.result?.res);
                    }
                    setTotalPages(Math.ceil(response?.data?.result?.totalCount / 20));
                    setTotalRecords(response?.data?.result?.totalCount);
                    setRecentInsertedBirdview(response?.data?.result?.latestRecord);
                }  else if(response?.data?.code !== 401) {
                    toast.error(response?.data?.message);
                }
            } catch (error) {
                toast.error("Failed to load data");
                console.error(error);
            } finally {
                setLoader(false);
                setInfLoader(false);
            }
        }
    };
    
    const DownloadBirdViewData = async (search = "", selectedLocation, dateRange, adType, selectedNewspaper, userType) => {
        try {
            setDownloadLoader(true)
            const response = await api({
                url: `/birdview/downloadBirdview`,
                method: "POST",
                responseType: "json",
                data: {
                    BirdViewSearch: search,
                    BirdViewSource: selectedLocation.length ? selectedLocation?.map(item => item.value) : [],
                    dateRange,
                    adType,
                    selectedNewspaper: selectedNewspaper.length ? selectedNewspaper.map(item => item.value) : [],
                    selectedBrandType: +selectedBrandType,
                },
            });
            setDownloadLoader(false)
            if (response?.code === 200) {
                const data = response.data?.map(item => ({
                    ...item,
                    Location: item?.Location?.map(id => getLocations(id) || []),
                    width: item.dimensions?.w ?? "",
                    height: item.dimensions?.h ?? "",
                    area: item.dimensions?.area ?? "",
                    color: item.dimensions?.color === 1 ? "Color" : item.dimensions?.color === 0 ? "B&W" : "",
                    price_per_unit: item.dimensions?.price_per_unit ?? ""
                }));
                setDownloadData(data ? data : []);
            }
        } catch (error) {
            console.error("Error @ DownloadBirdViewData", error)
        }
    }


    useEffect(() => {
        if (downloadData.length) {
            csvLinkRef?.current?.link?.click();
            setDownloadData([]);
        }
    }, [downloadData]);
    const getEstimatedValue = async (
      language,
      edition,
      ad_format,
      newspaper_name,
      location // add location param
    ) => {
      if (
        (localStorage.getItem("role") === roles.b2b ||
        localStorage.getItem("role") === roles.salesperson ) && !initialRender 
      ) {
        const locationValues = Array.isArray(location) ? location.map(l => l?.label) : [];
        const response = await api({
          url: `/birdview/estimatedvalue`,
          method: "POST",
          responseType: "json",
          data: {
            lang_id: language,
            edition: edition,
            ad_format: ad_format,
            newspaper_name: newspaper_name,
            location: locationValues.length ? locationValues : undefined
          },
        });
        if (response?.code === 200) {
          if(!firstBirdView.edition && flag !== 'add')
          {  
              let newBirdview={
                  lang_id: language || -1,
                  edition: edition || "",
                  ad_format: ad_format || "",
                  newspaper_name: newspaper_name || ""
              }
              setfirstBirdView(newBirdview);
              setValue('estimated_value',estimatedValue);

          }
        //   else if(firstBirdView.lang_id === language && firstBirdView.edition === edition && firstBirdView.ad_format === ad_format && firstBirdView.newspaper_name === newspaper_name)
        //   {   
        //       setValue('estimated_value',estimatedValue);
        //   }
          else
          {
              setValue('estimated_value',response?.data?.result?.estimated_value);
          }
          } else {
          toast.error(response?.data?.message)
      }
    }
  };




    const downloadUploadedFile = async (event) => {
        const file = event.target.files[0]
        if (event.target.files[0].type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
            setFileUrl("")
            return;
        }
        const formData = new FormData();
        formData.append("files", event.target.files[0]);
        try {
            let url = await api({
                url: `/upload/birdviewFile`,
                method: "POST",
                responseType: "json",
                data: formData,
                headers: { "Content-Type": "multipart/form-data" }
            });
            if (url.code === 200) {
                setFileUrl(url.data)
            } else {
                Toast("error", url.data.message);
            }
        } catch (error) {
            Toast("error", error);
        }
    }

    const [file, setFile] = useState(null);
    const [jsonData, setJsonData] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const handleFileUpload = async (event) => {
        setFile(event.target.files[0]);
        if (event.target.files[0]) {
            if (event.target.files[0].type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
                Toast('error', "Please upload file with .xlsx extension")
                return;
            }
            else {
                setIsLoading(true);
                try {
                    const arrayBuffer = await event.target.files[0].arrayBuffer();
                    const workbook = XLSX.read(arrayBuffer, { type: 'array' });
                    let sheetsCount = Object.keys(workbook.Sheets).length;

                    const sheetName = workbook.SheetNames[0];
                    const worksheet = workbook.Sheets[sheetName];

                    const customCellFormat = (cell, value) => {
                        if (cell.t === 'd' && typeof value === 'number') {
                            return new Date((value - (25567 + 1)) * 86400 * 1000); 
                        }
                        return value;
                    };

                    const convertedData = XLSX.utils.sheet_to_json(worksheet, {
                        raw: false, // Ensure that cell values are parsed
                        defval: '', // Provide a default value for empty cells
                        cellDates: true, // Enable cell date parsing
                        dateNF: 'DD/MM/YY', // Specify the date format
                        cellFormat: customCellFormat, // Use the custom cell format function
                    });

                    setJsonData(convertedData);
                    let response = await api({
                        url: `/birdview/uploadBirdViewFile`,
                        method: "POST",
                        responseType: "json",
                        data: {
                            convertedData,
                            sheetsCount
                        }
                    })
                    if (response.code === 200) {
                        if(response.data){
                            setUnknownBrands(response.data.missingBrands)
                            setShowUnknown(true)
                        }
                        else{
                        toast.success("Birdview Data added successfully");
                        loadData("", 0, selectedLocation, dateRange, adType, selectedNewspaper, userType);
                        loadSources();
                            loadNewspapers(watchLanguage?.value);
                        setFile(null)
                                                    
                        }
                    } else {
                        toast.error(response?.data?.message);
                        loadData(search, 0, selectedLocation, dateRange, adType, selectedNewspaper, userType);
                        loadSources();
                        loadNewspapers(watchLanguage?.value);
                        setFile(null)
                    }
                    downloadUploadedFile(event);
                    setIsLoading(false);
                } catch (error) {
                    console.error('Error converting Excel to JSON:', error);
                    setIsLoading(false);
                }
                // setValue('file_xlsx', '')
            }
        }
        else {
            return
        }

    };

    const handleFileInputChange = (e) => {
        handleFileUpload(e);
        downloadUploadedFile(e);
    };

    const [selectedRecords, setSelectedRecords] = useState([]);
    const [selectAll, setSelectAll] = useState(false);

    const toggleCheckbox = (recordId) => {
        if (selectedRecords.includes(recordId)) {
            setSelectedRecords(selectedRecords.filter((id) => id !== recordId));
        } else {
            setSelectedRecords([...selectedRecords, recordId]);
        }
    };

    const toggleSelectAll = () => {
        if (selectAll) {
            setSelectedRecords([]);
        } else {
            const pageRecordIds = data.map((item) => item.id);
            setSelectedRecords(pageRecordIds);
        }
        setSelectAll(!selectAll);
    };

    const deleteData = async (selectedRecords) => {
        try {
            let res = await api({
                url: `/birdview/delete`,
                method: "DELETE",
                responseType: "json",
                data: {
                    ids: selectedRecords
                }
            });
            if (res?.code !== 200) {
                Toast('error', res?.data?.message);
            } else {
                toast.success("Data Deleted Successfully");
                setCurrentPage(0);
                setSearch('');
                loadData("", 0, "All", dateRange, adType, selectedNewspaper, userType);
                loadSources();
                loadNewspapers(watchLanguage?.value);
                setSelectedRecords([]);
                setSelectAll(false)

            }
        } catch (error) {
            let er = error?.response?.message || "Something went wrong"
            Toast("error", er)
            if (error.response.status === 401)
                navigate("/")
        }
    }
    const handledelClose = () => {
        setDel(false)
    };



    const downloadSampleExcel = () => {
        const wb = XLSX.utils.book_new();
        const wsData = [['Ad_Type', 'Language', 'Category', 'Campaign_Name', 'Estimated_Price', 'Page_No', 'Page_Name', 'Ad_format', 'Edition', 'Location', 'Source', 'date', 'Newspaper_Name', 'Adv1_Name', 'Adv1_Mobile', 'Adv1_Designation', 'Adv1_Category', 'Adv1_Email', 'Adv2_Name', 'Adv2_Mobile', 'Adv2_Designation', 'Adv2_Category', 'Adv2_Email', 'Adv3_Name', 'Adv3_Mobile', 'Adv3_Designation', 'Adv3_Category', 'Adv3_Email', 'Adv4_Name', 'Adv4_Mobile', 'Adv4_Designation', 'Adv4_Category', 'Adv4_Email',
            'Adv5_Name', 'Adv5_Mobile', 'Adv5_Designation', 'Adv5_Category', 'Adv5_Email', 'Image_Url']]; // Column names
        const ws = XLSX.utils.aoa_to_sheet(wsData);
        XLSX.utils.book_append_sheet(wb, ws, 'SampleSheet');
        XLSX.writeFile(wb, 'SampleBirdView.xlsx'); // Download the file
    };
    const clearFileInput = () => {
        if (fileInputRef.current) {
            fileInputRef.current.value = null;
        }
    };

    const imageChange = async (e) => {
        setFileName(e.target.files[0].name);
        if (e.target.files && e.target.files.length > 0) {
            if (e.target.files[0].type === "image/jpg" || e.target.files[0].type === "image/jpeg" || e.target.files[0].type === "image/webp" || e.target.files[0].type === "image/png") {
                setUploadImage(e.target.files[0]);
            } else {
                Toast("error", "Only jpg, jpeg, webp, png formats accepted")
                setValue("upload_url", null)
            }
        } else {
            if (flag === "edit") {
                setImgUrl(imgUrl);
            } else {
                setProgress(0);
                setImgUrl("");
            }
        }
    };
    const formData = new FormData();
    formData.append("files", uploadImage);
    const imageUrl = async () => {
        try {
            let url = await api({
                url: `/upload/birdviewimage`,
                method: "POST",
                responseType: "json",
                data: formData,
                headers: { "Content-Type": "multipart/form-data" },
                onUploadProgress: data => {
                    setProgress(Math.round((100 * data.loaded) / data.total))
                },
            });
            if (url.code === 200) {
                setImgUrl(url.data.data);
                setUploadImage()
            } else {
                setProgress(0);
                setValue("upload_url", null);
                if (flag === "edit") setUploadImage("");
                Toast("error", url.data.message);
            }
        } catch (error) {
            Toast("error", error);
        }
    };
    const loadEditions = async (language) => {
        if (localStorage.getItem("role") === roles.b2b || localStorage.getItem("role") === roles.salesperson) {
            const response = await api({
                url: `/birdview/newspaper_editions`,
                method: "POST",
                responseType: "json",
                data: { lang_id: language }
            });
            if (response?.code === 200) {
                setEditions(response?.data?.result);
            }  else if(response?.data?.code !== 401) {
                toast.error(response?.data?.message)
            }
        }
    };

    const getColors = (brand) => {
        const brandLookup = newspaperData.filter((np) => np.name === brand);
        return {
            backgroundColor: brandLookup[0]?.background_color,
            color: brandLookup[0]?.color,
        };
    };

    useEffect(() => {
        if (localStorage.getItem("role") === roles.b2b || localStorage.getItem("role") === roles.salesperson) {
            loadEditions(watchLanguage?.value);

        }
    }, [watchLanguage?.value])

    useEffect(() => {
        if (fileName) {
            const removeExtension = (filename) => {
                return filename.replace(/\.[^/.]+$/, "");
            }

            // Remove the file extension from the fileName
            const fileNameWithoutExtension = removeExtension(fileName);

            const [brandname, paper, page, adtype, edition, language, ...rest] = fileNameWithoutExtension.split('_');

            // Filter out undefined values and check if the remaining length is 5
            const parts = [brandname, paper, page, adtype, edition, language, ...rest].filter(part => part !== undefined);

            if (parts.length === 6 || parts.length === 7) {

                // Find a brand that matches the given brand
                const matchedBrand = brands?.find(brand =>
                    brand.label?.toLowerCase() === brandname?.toLowerCase()
                );
                const matchedLang = langoptions?.find(lang =>
                    lang.label?.toLowerCase() === language?.toLowerCase()
                );

                // Find a newspaper that matches the paper
                const matchedNewspaper = newspapers?.find(newspaper =>
                    newspaper.label?.toLowerCase() === paper?.toLowerCase()
                );

                // Find an adtype that matches the given adtype
                const formattedAdtype = adtype?.replace(/\s+/g, '')?.toLowerCase();
                const matchedAdtype = AdFormatOptions?.find(adformat =>
                    adformat.label?.replace(/\s+/g, '')?.toLowerCase() === formattedAdtype
                );

                //  // Find an edition that matches the given edition
                const formattedEdition = edition?.replace(/\s+/g, '')?.toLowerCase();
                const matchedEdition = editions?.find(edition =>
                    edition.label?.replace(/\s+/g, '')?.toLowerCase() === formattedEdition
                );

                if (matchedLang) {
                    setValue('language', matchedLang);
                } else {
                    console.log("No matching lang found in fileName.");
                }

                if (matchedNewspaper) {
                    setValue('newspaper_name', matchedNewspaper);
                } else {
                    console.log("No matching newspaper found in fileName.");
                }

                if (page) {
                    setValue('page_no', page);
                } else {
                    console.log("No matching page found in fileName.");
                }

                if (matchedEdition) {
                    setValue('edition', matchedEdition);
                } else {
                    console.log("No matching edition found in fileName.");
                }

                if (matchedAdtype) {
                    setValue('ad_format', matchedAdtype);
                } else {
                    console.log("No matching adtype found in fileName.");
                }

                if (matchedBrand) {
                    setValue('brand_name', matchedBrand);
                } else {
                    console.log("No matching brand found in fileName.");
                }

                if (parts.length === 7) {
                    const location = parts[6];

                    //  // Find an edition that matches the given edition
                    const formattedLocation = location?.replace(/\s+/g, '')?.toLowerCase();
                    const matchedLocation = newspaperLocations?.find(location =>
                        location.label?.replace(/\s+/g, '')?.toLowerCase() === formattedLocation
                    );
                    if (matchedLocation) {
                        setValue('location', matchedLocation);
                    } else {
                        console.log("No matching location found in fileName.");
                    }
                } else {
                    console.log("No location found in fileName.");
                }

            } else {
                console.log("File name does not contain exactly 6 or 7 parts.");
            }
        }


    }, [fileName])

    useEffect(() => {
        if (uploadImage) {
            imageUrl();
        }
    }, [uploadImage]);

    useEffect(() => {
        if (localStorage.getItem("role") === roles.b2b || localStorage.getItem("role") === roles.salesperson) {
            loadData(search, 0, selectedLocation, dateRange, adType, selectedNewspaper, userType);
        }
    }, [search, selectedLocation, dateRange, adType, selectedBrandType, selectedNewspaper, userType,selectedCategory]);


    useEffect(() => {
        if (localStorage.getItem("role") === roles.b2b || localStorage.getItem("role") === roles.salesperson) {
            loadSources();
            loadNewspapers(watchLanguage?.value);
        }
        fetchNewsPapers();
    }, []);

    useEffect(() => {
        if (localStorage.getItem("role") === roles.b2b || localStorage.getItem("role") === roles.salesperson) {
            loadLocations();

        }
    }, [adType])

    useEffect(() => {
        if (
            localStorage.getItem("role") === roles.b2b ||
            localStorage.getItem("role") === roles.salesperson
        ) {
            getEstimatedValue(
                watchLanguage?.value,
                watchEdition?.value,
                watchAdFormat?.label,
                watchNewspaperName?.value,
                watchLocation // pass location
            );
        }
    }, [
        watchLanguage?.value,
        watchEdition?.value,
        watchAdFormat?.label,
        watchNewspaperName?.value,
        watchLocation
    ]);

    useEffect(() => {
        if (localStorage.getItem("role") === roles.b2b || localStorage.getItem("role") === roles.salesperson) {
            loadNewspapers(watchLanguage?.value);

        }
    }, [watchLanguage?.value])

    useEffect(() => {
        if (localStorage.getItem("role") === roles.b2b || localStorage.getItem("role") === roles.salesperson) {
            loadNewspaperLocations(watchLanguage?.value, watchEdition?.value);

        }
    }, [watchLanguage, watchEdition])


    const csvHeaders = [
        { label: "Ad_type", key: "Ad_type" },
        { label: "Brand_Type", key: "Brand_Type" },
        { label: "Language", key: "Language" },
        { label: "Category", key: "Category" },
        {label:'Brand_Name',key:'brand_name'},
        { label: "Campaign_Name", key: "Campaign_Name" },
        { label: "Estimated_Price", key: "Estimated_Price" },
        { label: "Page_No", key: "Page_No" },
        { label: "Page_Name", key: "Page_Name" },
        { label: "Page Type", key: "page_type" },
        { label: "Ad_format", key: "Ad_format" },
        { label: "Edition", key: "Edition" },
        { label: "Location", key: "Location" },
        { label: "Source", key: "Source" },
        { label: "date", key: "date" },
        { label: "Newspaper_Name", key: "Newspaper_Name" },
        { label: "Image_url", key: "Image_Url" },
        { label: "Original_url", key: "original_url" },
        { label: "Width", key: "width" },
        { label: "Height", key: "height" },
        { label: "Area", key: "area" },
        { label: "Color", key: "color" },
        { label: "Price_Per_Unit", key: "price_per_unit" }
    ];

    const handleNextClick = async () => {
        if (clickindex === data?.length - 1) {
            if (currentPage < Math.ceil(totalRecords / 100)) {
                if (currentPage !== 0) {
                    await loadMoreData(currentPage + 1);
                } else {
                    loadMoreData(((data?.length) / 100));
                }
            }
        }
    };
    const handlePrevClick = () => {
        if (currentPage > 0) {
            loadPrevData(currentPage - 1);
            setCurrentPage((prevPage) => prevPage - 1);
        }
    };
    const loadMoreData = async (page) => {
        try {
            setLoader(true);
            setIsLoading(true)
            let res = await api({
                url: `/birdview/get`,
                method: "POST",
                responseType: "json",
                data: {
                    BirdViewSearch: search,
                    page,
                    BirdViewSource: selectedLocation,
                    dateRange,
                    category_ids:selectedCategory.map((cat) => cat.value),
                    limit: 100
                },
            });
            if (res?.code === 200) {
                setData((prevData) => [...prevData, ...res?.data?.result?.res]);
                setLoader(false);
                setIsLoading(false)
            }  else if(res?.data?.code !== 401) {
                toast.error(res?.data?.message)
            }
        } catch (error) {
            setLoader(false);
            if (error?.response?.status === 401) navigate("/");
        }
    };
    const loadPrevData = async (page) => {

        try {
            setLoader(true);
            setIsLoading(true);
            let res = await api({
                url: `/birdview/get`,
                method: "POST",
                responseType: "json",
                data: {
                    BirdViewSearch: search,
                    page,
                    BirdViewSource: selectedLocation,
                    dateRange,
                    category_ids:selectedCategory.map((cat) => cat.value),
                    limit: 100
                },
            });
            if (res?.code === 200) {
                setClickIndex(res?.data?.result?.res?.length);
                setData((prevData) => [...res?.data?.result?.res, ...prevData]);
                setLoader(false);
                setIsLoading(false);
            } else {
                console.error(res?.data?.message)
            }
        } catch (error) {
            setLoader(false);
            if (error?.response?.status === 401) navigate("/");
        }
    };

    const userDetails = async () => {
        if (localStorage.getItem('role') === roles.salesperson) {

            let headDetails = await api({
                url: `/birdview/userDetails`,
                method: "POST",
                responseType: "json"
            });
            if (headDetails.data) {
                const userData = headDetails?.data?.result
                if (userData.user_type === -1) {
                    setUserType("MainHead")
                    setAdType("Finite")
                }
                else if (userData.user_type === 1 && userData.region === -1 && userData.location === -1) {
                    setUserType("NationalHead");
                    setAdType("Finite")
                }
                else if (userData.user_type === 2 && userData.region === -1 && userData.location === -1) {
                    setUserType("LocalHead")
                    setAdType("Finite")


                }
                else if (userData.user_type === 1 && userData.region !== -1 && userData.location === -1) {
                    setUserType("RegionHead");
                    setAdType("Finite")

                }
                else if (userData.user_type === 1 && userData.region !== -1 && userData.location !== -1) {
                    setUserType("NationalUser")
                    setAdType("Finite")

                }
                else if (userData.user_type === 2 && userData.region !== -1) {
                    setUserType("LocalUser")
                    setAdType("Finite")

                }

            }
        }
    }

    const [scrolltopdata, setscrolltopdata] = useState('');


    const handleCheckboxChange = (brand) => {
        setSlectedBrands((prevSelectedRows) => {
          const index = prevSelectedRows.findIndex((item) => item === brand);
          if (index !== -1) {
            return prevSelectedRows.filter((item, idx) => idx !== index);
          } else {
            return [...prevSelectedRows, brand];
          }
        });
      };

      const addBrands = async() =>{
        try {
            let res = await api({
                url:'/birdview/insertMissingBrands',
                method:'POST',
                responseType:'json',
                data:{
                    brands:selectedBrands
                }
            })
            if(res.code === 200){
                Toast('success','New brands added successfully!')
                setCompletedBrands([...completedBrands, ...selectedBrands])
                setSlectedBrands([])
            }
        } catch (error) {
            console.error(error)
        }
      }
      const MergeBrands = async()=>{
        if(choosedBrand){
        try {
            let res = await api({
                url:'/birdview/mergeMissingBrands',
                method:'POST',
                responseType:'json',
                data:{
                    merge_into:choosedBrand,
                    brands:selectedBrands
                }
            })
            if(res.code === 200){
                Toast('success','Brands Merged successfully!')
                setCompletedBrands([...completedBrands, ...selectedBrands])
                setSlectedBrands([])
                setMerge(false)
                setChoosedBrand()
            }
        } catch (error) {
            console.error(error)
        }
    }
    else{
        Toast('warning', "Please select the brand")
    }
      }
      const fetchBrands = async () => {
        try {
          let res = await api({
            url: "/birdview/allBrands",
            method: "POST",
            responseType: "json",
            data: {
              exclude_brandIds: [],
            },
          });
          if (res.code === 200) {
            setMainBrand(res.data.result);
          }
        } catch (error) {
          console.error(error);
        }
      };
      const completeUnknownBrands = async()=>{
        let res = await api({
            url:'/birdview/dumpintoMasterBirdView',
            method:'POST',
            responseType:'json',
            data:{}
        })
        if(res.code === 200){
            setCompletedBrands([])
            setSlectedBrands([])
            setUnknownBrands([])
            setShowUnknown(false)
            loadData(search, 0, selectedLocation, dateRange, adType, selectedNewspaper, userType)
        }
      }



    // Function to set today's date as default
    const setDefaultDate = () => {
        const prevDate = localStorage.getItem('birdview_date');
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0');
        const day = String(today.getDate()).padStart(2, '0');
        const formattedToday = `${year}-${month}-${day}`;
        if(prevDate){
            setDate(prevDate);
        }
        else {
            localStorage.setItem('birdview_date',formattedToday);
            setDate(formattedToday);
        }
    };

    useEffect(() => {
        userDetails();
    }, [])

    useEffect(() => {
        if (merge) {
            fetchBrands()
        }
    }, [merge])

    useEffect(() => {
        window.addEventListener('scroll', () => {
            if (window.scrollY < 15) {
                setscrolltopdata('');
            } else {
                setscrolltopdata('scrolled');
            }
        });
    }, [])
    // Set default date on component mount
    useEffect(() => {
        setDefaultDate();
    }, []);

    // useEffect(() => {
    //     if(flag && watchBrandType && watchEdition) getBrands(watchBrandType, watchEdition?.value)
    // }, [watchBrandType, watchEdition?.value, flag])

    useEffect(() => {
        if(currentPage !== 0)
            loadData(search,
                currentPage,
                selectedLocation,
                dateRange,
                adType,
                selectedNewspaper,
                userType)
    }, [currentPage])
   
    const lastItemRef = useCallback(node => {
        if(loader) return
        if (observer.current) observer.current.disconnect();
        observer.current = new IntersectionObserver(entries => {
          if (entries[0].isIntersecting ) {
            if(data?.length < totalRecords){
                setInfLoader(true)
                setCurrentPage(prevPage => prevPage + 1);
            }
          }
        });
        if (node) observer.current.observe(node);
      }, [loader]);

      const getBrandsAlias = async(checker) =>{
        try {
          if(!checker )
              return []
          let requestObj = {search : checker,  brand_type: watchBrandType}  
          const brandsResult = await api({
            url: 'user/sales_persons/getBrands',
            method:"POST",
            responseType:"json",
            data: requestObj
          })
          if(brandsResult?.code === 200){
            setBrands(brandsResult.data)
            return brandsResult.data
          }
          else 
            return []
        } catch (error) {
          console.error("Error @ getBrands",error)
        }
      }
      const debouncedGetBrands = debouncePromise(getBrandsAlias, 500); // Adjust the delay as needed

      const searchFilterOnChange = (e) =>{
        setSearch(e.target.value); setData([]); setCurrentPage(0) 
      }
      const defaultValue = (options, value) => {
        return options ? options.filter((option) => option.value === value) : "";
      };

    return (
        <>
            <div className={`flex gap-2 justify-end mb-4 items-center stickyFilters ${scrolltopdata}`}>
                <div className="flex gap-4 justify-end mobHide flex-wrap">
                    <div>
                        <Button onClick={()=>setShowSummary(true)}>Show Summary</Button>
                    </div>
                    <div>
                        <Select
                            className='flex flex-wrap'
                            name='category'
                            size='medium'
                            placeholder='Select newspaper category'
                            value={selectedCategory}
                            onChange={(selected) => {
                                setSelectedCategory(selected);
                            }}
                            options={newspaper_categories}
                            isMulti
                        />
                        
                    </div>
                    <div>
                        <Select
                        className=''
                        placeholder="Select District"
                        name="source"
                        size="medium"
                        value={selectedLocation}
                        onChange={(selected) => {
                          setSelectedLocation(selected || []); setData([]); setCurrentPage(0)
                        }}
                        options={[...locations]}
                        isMulti
                    />
                    </div>
                    <div>
                    <Select
                        className=''
                        placeholder="Select Newspaper"
                        name="source"
                        size="medium"
                        value={selectedNewspaper}
                        onChange={(selected) => {
                          setSelectedNewspaper(selected || []); setData([]); setCurrentPage(0)
                        }}
                        options={[...newspaperData.filter(item => item.name !== 'Way2news').map(item => {return {label: item.name, value: item.name}})]}
                        isMulti
                    />
                    </div>

                <div>
                    <SlSelect
                        className='w-40'
                        placeholder="Select Ad Type"
                        name="adType"
                        size="medium"
                        value={adType}
                        onSlChange={(e) => { (setAdType(e.target.value)); setData([]); setCurrentPage(0) }}
                    >
                            <SlOption key={0} value={"Finite"}>Finite</SlOption>
                            <SlOption key={1} value={"Infinite"}>Infinite</SlOption>
                    </SlSelect>
                </div>
                <div>
                    <SlSelect
                        className='w-40'
                        placeholder="Select Brand Type"
                        name="adType"
                        size="medium"
                        value={selectedBrandType}
                        onSlChange={(e) => { (setSelectedBrandType(e.target.value)); setData([]); setCurrentPage(0) }}
                    >
                            <SlOption key={0} value={'0'}>All</SlOption>
                            <SlOption key={1} value={'1'}>National</SlOption>
                            <SlOption key={2} value={'2'}>Local</SlOption>
                            <SlOption key={3} value={'3'}>Metro</SlOption>
                            <SlOption key={4} value={'4'}>Local-TN</SlOption>
                    </SlSelect>
                </div>
                    

                <SlInput className='w-full' size='medium' placeholder='Newspaper/Edition/Adv Name '
                    onSlInput={debounce(searchFilterOnChange, 500)} style={{ width: '230px' }}
                >
                    <SlIcon library="lucide" name="search" slot="prefix"></SlIcon>
                </SlInput>
                <div className="border rounded-lg min-w-fit h-fit">
                    <Datepicker
                        classNames="form-input "
                        value={dateRange}
                        primaryColor={"cyan"}
                        showShortcuts={true}
                        useRange={true} // Allow date range selection
                        configs={{
                            shortcuts: {
                                today: "today",
                                yesterday: "yesterday",
                                currentMonth: "currentMonth",
                                pastMonth: "lastMonth",

                            }
                        }}
                        onChange={handleDateRange}
                    />
                </div>
                </div>
                <img src={filterSvg} alt="filter" onClick={() => setShowFilter(true)} className="w-6 mobileOnly"></img>
                {<div className="flex justify-end">
                    {selectedRecords.length > 0 && (
                        <SlButton variant="primary" size="small" onClick={async () => { setDel(true) }}>Delete Selected</SlButton>
                    )}
                </div>}



                    {(localStorage.getItem("role") === roles.b2b) ? (
                    <>
                        <CSVLink
                            data={downloadData}
                            headers={csvHeaders}
                            filename={`birdview_data.csv`}
                            ref={csvLinkRef} // Assign the ref to the CSVLink component
                        >
                        </CSVLink>
                    {downloadLoader ? <TableLoader/> : <i className="bi bi-download px-2 py-1 rounded-lg  bg-slate-100 hover:text-cyan-500 cursor-pointer hover:bg-slate-150" data-toggle="tooltip" title="Download Birdview Data"  onClick={() => DownloadBirdViewData(search, selectedLocation, dateRange, adType, selectedNewspaper)}></i> }
                    </>) : null}

                {(localStorage.getItem("role") === roles.b2b) ? (<div>
                    <SlButton variant="primary" size="small" onClick={() => {
                        setInitialRender(false);
                        handleShow("add");
                        setFlag("add");
                    }}>Add BirdView</SlButton>
                </div>) : null}
            </div >
            <SlDrawer label={flag === "edit" ? "Edit BirdView" : "Add Birdview"} open={show} onSlRequestClose={handleRequestClose} onSlAfterHide={handleClose} style={{ '--size': '640px' }}>

                <form onSubmit={handleSubmit(onSubmit)} encType="multipart/form-data">
                    {/* Date Field */}
                    <div className="mb-3">
                        <label>Date</label><span className="text-red-600">*</span>
                        <input
                            type="date"
                            className="form-control"
                            placeholder="Choose Date"
                            {...register('date', { required: 'Date is required' ,onChange:(e)=>{localStorage.setItem('birdview_date',e.target.value);setDate(e.target.value)}})}
                        />
                        {submit && errors.date && <div className="text-red-600">{errors.date.message}</div>}
                    </div>

                    {/* Language */}
                    <div className="mb-3">
                        <label className="form-label">Language</label>
                        <Controller
                            name="language" // Set the name to "language"
                            control={control}
                            rules={{ required: 'Language is required' }}
                            render={({ field }) => (
                                <Select
                                    {...field}
                                    name="language" // Ensure the name is consistent
                                    placeholder="Select Language"
                                    options={langoptions}
                                    className="basic-multi-select"
                                    classNamePrefix="select"
                                />
                            )}
                        />
                        {submit && errors.language && <div className="text-red-600">{errors.language.message}</div>}
                    </div>

                    {/* Newspaper Name */}
                    <div className="mb-3">
                        <label className="mb-1">Newspaper Name</label><span className="text-red-600">*</span>
                        <Controller
                            control={control}
                            name="newspaper_name"
                            // rules={{ required: true }}
                            rules={{ required: 'Newspaper Name is required' }}
                            render={({ field }) => (
                                <Select
                                    {...field}
                                    name="newspaper_name" // Ensure the name is consistent
                                    placeholder="Select Newspaper Anme"
                                    options={newspapers}
                                    className="basic-multi-select"
                                    classNamePrefix="select"
                                />
                            )}
                        />
                        {submit && errors.newspaper_name && <div className="text-red-600">{errors.newspaper_name.message}</div>}
                    </div>

                    {/* Page Number */}
                    <div className="mb-3">
                        <label className="mb-1">Page Number</label>
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Page Number"
                            {...register('page_no')}
                        />
                        {submit && errors.page_no && <div className="text-red-600">{errors.page_no.message}</div>}
                    </div>

                    {/* Edition */}
                    <div className="mb-3">
                        <label className="form-label">Edition</label>
                        <Controller
                            name="edition" // Set the name to "edition"
                            control={control}
                            rules={{ required: true }}
                            render={({ field }) => (
                                <Select
                                    {...field}
                                    name="edition" // Ensure the name is consistent
                                    placeholder="Select Edition"
                                    options={editions}
                                    className="basic-multi-select"
                                    classNamePrefix="select"
                                />
                            )}
                        />
                        {submit && errors.edition && <div className="text-red-600">{errors.edition.message}</div>}
                    </div>
                    {/* Location */}
                    {watch('edition')?.value?.toLowerCase().includes('district') && (
                        // <div className="mb-3">
                        //     <label className="mb-1 mr-2">Location</label>
                        //     <button
                        //         type="button"
                        //         className="btn btn-primary"
                        //         onClick={() => setIsModalOpen(true)}
                        //     >
                        //         Add Location
                        //     </button>
                        //     {isModalOpen && (
                        //         <div className="mb-3 new-location">
                        //     <div>
                        //         <label className="mb-1">Add New Location</label>
                        //         <input
                        //             type="text"
                        //             className="form-control"
                        //                     placeholder="Enter New Location Name"
                        //                     aria-label="New Location Name"
                        //             name="newLocation"
                        //                     value={newLocation}
                        //             onChange={handleInputChange}
                        //         />
                        //                 <span style={{ color: 'red' }}>{newLocationErr}</span>
                        //     </div>
                        //     <div>
                        //         <label className="mb-1">State</label>
                        //         <select
                        //             className="form-select"
                        //             aria-label="Select State"
                        //                     name="newLocationState"
                        //             value={newLocationState}
                        //             onChange={handleLocationStateInputChange}
                        //         >
                        //             <option value="">Select State</option>

                        //             {BirdviewStates.map((option) => (
                        //                 <option key={option.value} value={option.value}>
                        //                     {option.label}
                        //                 </option>
                        //             ))}
                        //         </select>
                        //                 <span style={{ color: 'red' }}>{newLocationStateErr}</span>
                        //     </div>
                        //     <div className="fullWidth">
                        //                 <button
                        //                     type="button"
                        //                     className="btn btn-primary mt-2"
                        //                     onClick={handleAddLocation}
                        //                 >
                        //             Add
                        //         </button>
                        //                 <button
                        //                     type="button"
                        //                     className="btn btn-secondary mt-2"
                        //                     onClick={handleModalClose}
                        //                 >
                        //             Cancel
                        //         </button>
                        //     </div>
                        // </div>
                        //     )}
                           
                        // </div>
                        <div>
                            <label className="mb-1 mr-2">District</label>
                             <Controller
                                control={control}
                                name="location"
                                render={({ field }) => (
                                    <Select
                                        {...field}
                                        name="location" // Ensure the name is consistent
                                        placeholder="Select District"
                                        options={newspaperLocations}
                                        className="basic-multi-select"
                                        classNamePrefix="select"
                                        isMulti
                                    />
                                )}
                            />
                            {errors.location && <div className="text-red-600">{errors.location.message}</div>}
                            </div>
                    )}

                    {/* Ad Format */}
                    <div className="mb-3">
                        <label className="mb-1">Ad Format</label><span className="text-red-600">*</span>
                        <Controller
                            control={control}
                            name="ad_format"
                            rules={{ required: 'Ad Format is required' }}
                            render={({ field }) => (
                                <Select
                                    {...field}
                                    name="ad_format" // Ensure the name is consistent
                                    placeholder="Select Ad Format"
                                    options={AdFormatOptions}
                                    className="basic-multi-select"
                                    classNamePrefix="select"
                                />
                            )}
                        />
                        {errors.ad_format && <div className="text-red-600">{errors.ad_format.message}</div>}
                    </div>

                    {/* Estimated Price */}
                    <div className="mb-3">
                        <label className="mb-1">Estimated Price</label><span className="text-red-600">*</span>
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Estimated Price"
                            aria-label="Estimated Price"
                            {...register('estimated_value', { required: 'Estimated Price is required' })}
                        />
                        {errors.estimated_value && <div className="text-red-600">{errors.estimated_value.message}</div>}
                    </div>

                    {/* Campaign Name Field */}
                    <div className="mb-3">
                        <label className="mb-1">Campaign Name</label><span className="text-red-600">*</span>
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Campaign Name"
                            aria-label="Campaign Name"
                            {...register('campaign_name', { required: 'Campaign Name is required' })}
                        />
                        {errors.campaign_name && <div className="text-red-600">{errors.campaign_name.message}</div>}
                    </div>

                    {/* Brand Type Finite or infinite */}
                    <div className="mb-3">
                        <label className="mb-1">Brand Type</label>
                        <div className="d-flex gap-3">
                            <input
                                type="radio"
                                id="finite"
                                {...register('brand_type')}
                                value="finite"
                                defaultChecked
                                onChange={() => {setValue('brand_type', 'finite'); setValue('brand_name', "")}}
                            />
                            <label htmlFor="finite">Finite Brands</label>
                            <input
                                type="radio"
                                id="vbrand"
                                {...register('brand_type')}
                                value="infinite"
                                onChange={() => {setValue('brand_type', 'infinite'); setValue('brand_name', "")}}
                            />
                            <label htmlFor="vbrand">Infinite Brands</label>
                        </div>
                    </div>

                    {/* Brand Name */}
                    <div className="mb-3">
                        <label className="mb-1">Brand Name</label><span className="text-red-600">*</span>
                        <Controller
                            control={control}
                            name="brand_name"
                            rules={{ required: 'Brand Name is required' }}
                            render={({ field }) => (
                        <AsyncSelect
                                    {...field}
                                    name="brand_name" // Ensure the name is consistent
                                    className="basic-multi-select"
                                    classNamePrefix="select"
                                    loadOptions={debouncedGetBrands}
                                    defaultOptions={brands}
                                    value= {defaultValue(brands, getValues('brand_name'))}
                                    onChange={selected => setValue('brand_name', selected?.value)}
                                    />
                                )}
                                />

                        {errors.brand_name && <div className="text-red-600">{errors.brand_name.message}</div>}
                    </div>

                    {/* Upload Image */}
                    <div className="mb-3">
                        <label className="form-label">Upload Image</label><br />
                        <input
                            className="form-control mb-2"
                            type="file"
                            id="formFile"
                            name="files"
                            {...register("upload_url", {
                                required: flag === "edit" ? false : true,
                                onChange: (e) => imageChange(e),
                            })}
                        />

                        {errors.upload_url && (
                            <p className="text-red-600">Image is required!</p>
                        )}
                        {
                            progress > 0 && progress < 100 ? <SlProgressBar value={progress}>{progress}%</SlProgressBar> : imgUrl !== "" ? (
                                <span>{`${imgUrl}`}</span>
                            ) : (
                                    flag === "edit" && <span>{`${imgUrl}`}</span>
                            )}
                    </div>

                    {/* Submit Button */}
                    <div className="mb-3">
                        <button type="submit" disabled={isSubmitting} className="btn btn-primary" onClick={() => setSubmit(true)}>Submit</button>
                    </div>
                </form>
            </SlDrawer>

            
            
            {// New infinite scrolling
            (data?.length && !loader) ? (
                        <div className="birdviewWrapper">
                            <ul className="birdview">
                                {data.map((item, index) => {
                                    if(data.length !== index + 1){
                                    return (
                                        <li key={item.id}>
                                            <div className="theme">
                                                {(item?.image_url) ? (<img src={item.image_url} alt="placeholder" />) : (<img src={NoImage} alt="placeholder" />)}
                                                <div className="blur"> {(item?.image_url) ? (<img src={item.image_url} alt="placeholder" />) : (<img src={NoImage} alt="placeholder" />)}</div>
                                                <div className="publisher">
                                                    {item?.newspaper_name ? (
                                                        <h6 style={getColors(item?.newspaper_name)}>
                                                            {item.newspaper_name}
                                                        </h6>
                                                    ) : null}
                                                    {(item?.ad_type === "Local") ? (<h6 className="local">{item.ad_type}</h6>) : ((item?.ad_type === "National") ? (<h6 className="national">{item.ad_type}</h6>) : (<h6 className="districts">{item.ad_type}</h6>))}
                                                </div>
                                                <p className="location"><img src={LocationSVG} alt="location_name" title={item.location} />{getLocations(item.location)}</p>
                                                <p className="estimation">Est Val: <strong>{item.estimated_value || 0}</strong></p>
                                                {item.image_url ? (<Button className="previewBtn" variant="neutral" onClick={() => { setImgSrc(item.image_url); setOpen(true) }}>
                                                    Preview
                                                </Button>) : null}
                                                 {localStorage.getItem('role') === roles.salesperson ?  <button onClick={()=>{
              setReportId(item.id);
              setReportImageUrl(item.image_url)
              setShowReport(true)
             }} className="border-[1px] !z-10 !border-red-500 bg-white text-xs font-bold text-red-500 px-2 py-1 rounded-md absolute right-2 top-2 flex gap-1 items-center hover:text-white hover:!bg-red-500"><sl-icon library="lucide" name="alert-triangle"></sl-icon><span>Report</span></button> : null}
                                            </div>
                                            <div className="description">
                                                {(item?.page_no) ? (<p>Page {item.page_no} : {formatDate(item.date)}</p>) : (<p>Page -  : {formatDate(item.date)}</p>)}
                                                <h1>{item.campaign_name || " "}</h1>
                                                <h5>Edition : {item.edition || " "}</h5>
                                                <h5>Ad Format : {item.ad_format || " "} </h5>
                                                <h5>Brand Name : {item.brand_name || " "} </h5>
                                            </div>

                                            <div className="moreOptions">
                                                {(localStorage.getItem("role") === roles.b2b) ? (<div className="option" onClick={async () => {
                                                    setInitialRender(true);
                                                    handleShow("edit", item);
                                                    setFlag("edit");
                                                    setId(item.id)
                                                }}>
                                                    <img src={EditIcon} alt="" />
                                                    <h6>Edit</h6>
                                                </div>) : null}
                                                <div className="option" onClick={async () => { setId(item.id); await advData(item.id) }}>
                                                    <img src={UserIcon} alt="" />
                                                    <h6>Adv</h6>
                                                </div>
                                                <div className="option" onClick={()=>{setShowDialog(item.id)}}>
                                                        <img src={LocationSVG} alt="" />
                                                        <h6>Locaitons</h6>
                                                    </div>
                                            </div>
                                            <SlDialog label="Location Details" open={item.id === showDialog} onSlAfterHide={()=> setShowDialog(null)}>
                                                <p>{getLocations(item.location)}</p>
                                            </SlDialog>
                                        </li>)
                                    }else{
                                        return (
                                            <li  ref={index === data.length - 1? lastItemRef : null} key={item.id}>
                                                <div className="theme">
                                                    {(item?.image_url) ? (<img src={item.image_url} alt="ads" />) : (<img src={NoImage} alt="placeholder" />)}
                                                    <div className="blur"> {(item?.image_url) ? (<img src={item.image_url} alt="ads" />) : (<img src={NoImage} alt="placeholder" />)}</div>
                                                    <div className="publisher">
                                                        {item?.newspaper_name ? (
                                                            <h6 style={getColors(item?.newspaper_name)}>
                                                                {item.newspaper_name}
                                                            </h6>
                                                        ) : null}
                                                        {(item?.ad_type === "Local") ? (<h6 className="local">{item.ad_type}</h6>) : ((item?.ad_type === "National") ? (<h6 className="national">{item.ad_type}</h6>) : (<h6 className="districts">{item.ad_type}</h6>))}
                                                    </div>
                                                    <p className="location"><img src={LocationSVG} alt="location_name" title={item.location} />{getLocations([item.location])}</p>
                                                    <p className="estimation">Est Val: <strong>{item.estimated_value || 0}</strong></p>
                                                    {item.image_url ? (<Button className="previewBtn" variant="neutral" onClick={() => { setImgSrc(item.image_url); setOpen(true) }}>
                                                        Preview
                                                    </Button>) : null}
                                                      {localStorage.getItem('role') === roles.salesperson ? <button onClick={()=>{
              setReportId(item.id);
              setReportImageUrl(item.image_url)
              setShowReport(true)
             }} className="border-[1px] !z-10 !border-red-500 bg-white text-xs font-bold text-red-500 px-2 py-1 rounded-md absolute right-2 top-2 flex gap-1 items-center hover:text-white hover:!bg-red-500"><sl-icon library="lucide" name="alert-triangle"></sl-icon><span>Report</span></button> : null}
                                                </div>
                                                <div className="description">
                                                    {(item?.page_no) ? (<p>Page {item.page_no} : {formatDate(item.date)}</p>) : (<p>Page -  : {formatDate(item.date)}</p>)}
                                                    <h1>{item.campaign_name || " "}</h1>
                                                    <h5>Edition : {item.edition || " "}</h5>
                                                    <h5>Ad Format : {item.ad_format || " "} </h5>
                                                    <h5>Brand Name : {item.brand_name || " "} </h5>

                                                </div>
    
                                                <div className="moreOptions">
                                                    {(localStorage.getItem("role") === roles.b2b) ? (<div className="option" onClick={async () => {
                                                        setInitialRender(true);
                                                        handleShow("edit", item);
                                                        setFlag("edit");
                                                        setId(item.id)
                                                    }}>
                                                        <img src={EditIcon} alt="" />
                                                        <h6>Edit</h6>
                                                    </div>) : null}
                                                    <div className="option" onClick={async () => { setId(item.id); await advData(item.id) }}>
                                                        <img src={UserIcon} alt="" />
                                                        <h6>Adv</h6>
                                                    </div>
                                                    <div className="option">
                                                        <img src={LocationSVG} alt="" />
                                                        <h6>Locaitons</h6>
                                                    </div>
                                                </div>
                                                <SlDialog label="Location Details" open={item.id === showDialog} onSlAfterHide={()=> setShowDialog(null)}>
                                                <p>{getLocations(item.location)}</p>
                                            </SlDialog>
                                            </li>)
                                    }
                                })}
                            </ul>
                        </div>
                    ) : ((!data?.length && !loader) ? (
                        <NoDataFound colspan="17" />
                        ) : (
                            <div className="d-flex justify-content-center">
                            <div className="spinner-border" role="status">
                                <span className="sr-only">Loading...</span>
                            </div>
                                </div>)
                    )}
                    {
                       infLoader ?  <div className="w-full d-flex justify-center items-center"><TableLoader /> </div> : null
                    }
            {/* <div className={`flex justify-end stickBottom ${scrolltopdata}`}>
                {totalPages > 1 && (
                    <Paginator
                        pageCount={totalPages}
                        handlePageClick={handlePageClick}
                        forcePage={currentPage} />)}
            </div> */}


            <SlDrawer
                label={"Advertiser Details"}
                open={preview}
                onSlRequestClose={handleRequestClose}
                onSlAfterHide={() => { setPreview(false); setId("") }}
                style={{ "--size": "70vw" }}
            >
                <div className="flex justify-end mb-5">
                </div>
                <div className="overflow-x-auto">
                    <table className="table table-bordered">
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Designation</th>
                                <th>Email</th>
                                <th>Category</th>
                                <th>Mobile Number</th>

                            </tr>
                        </thead>
                        {advDetails?.length && !loader ? (
                            <tbody>
                                {advDetails.map((item, index) => {
                                    return (
                                        <tr key={index}>
                                            <td >{item.adv_name || "-"}</td>
                                            <td>{item.adv_designation || "-"}</td>
                                            <td >{item.adv_email || "-"}</td>
                                            <td>{item.adv_category || "-"}</td>
                                            <td >{item.adv_phone || "-"}</td>

                                        </tr>
                                    );
                                })}
                            </tbody>
                        ) : !advDetails?.length && !loader ? (
                            <NoDataFound colspan="8" />
                        ) : (
                            <TableLoader colspan="8" />
                        )}
                    </table>
                </div>
            </SlDrawer>

            {/* <Modal className="birdview-image-preview" show={open} onHide={() => setOpen(false)}>
                <Modal.Header closeButton>Image Preview
                </Modal.Header>
                <Modal.Body>
                    <img src={imgSrc} alt="" />
                </Modal.Body>
            </Modal > */}
    <Modal 
          className="birdview-image-preview" 
          show={open} 
          onHide={() => setOpen(false)}
          size="xl"
        >
            <Modal.Header closeButton>
            <span className="text-base font-medium">Image Preview - Complete Edge Coverage</span>
            </Modal.Header>
            <Modal.Body className="p-0">
            <div className="grid grid-cols-1 lg:grid-cols-6 gap-0">
                {/* Original Image */}
                <div className="lg:col-span-3 p-6 bg-gray-50">
                <div
                    className="relative bg-white rounded-lg shadow-lg p-2"
                    onMouseEnter={() => setShowMagnifier(true)}
                    onMouseMove={handleMouseMove}
                    onMouseLeave={() => setShowMagnifier(false)}
                >
                    <img 
                    ref={imgRef}
                    src={imgSrc} 
                    alt="" 
                    className="w-full h-auto block rounded cursor-crosshair"
                    />
                </div>
                </div>

                {/* Zoomed Panel - Shows ALL edges clearly */}
                <div className="lg:col-span-3 p-6 bg-gray-100 border-l border-gray-300">
                <div className="sticky top-4 bg-white rounded-lg shadow-xl">
                    <div className="bg-gradient-to-r from-blue-600 to-blue-700 text-white px-4 py-3 rounded-t-lg">
                    <div className="flex items-center justify-between">
                        <span className="font-semibold">🔍 Zoomed View</span>
                        <span className="bg-white bg-opacity-20 px-2 py-1 rounded text-xs">
                        {zoomLevel}x
                        </span>
                    </div>
                    <p className="text-xs text-blue-100 mt-1">Hover anywhere - including edges</p>
                    </div>
                    
                    {showMagnifier ? (
                    <div 
                        className="w-full h-96 rounded-b-lg overflow-hidden"
                        style={{
                        backgroundImage: `url(${imgSrc})`,
                        backgroundPosition: `${position.x}% ${position.y}%`,
                        backgroundSize: `${zoomLevel * 100}%`,
                        backgroundRepeat: 'no-repeat',
                        imageRendering: '-webkit-optimize-contrast',
                        filter: 'contrast(1.1)',
                        }}
                    />
                    ) : (
                    <div className="w-full h-96 rounded-b-lg flex items-center justify-center bg-gray-50">
                        <div className="text-center">
                        <div className="text-4xl mb-2">👆</div>
                        <p className="text-gray-500 text-sm">Hover over image</p>
                        <p className="text-gray-400 text-xs mt-1">to see zoomed view</p>
                        </div>
                    </div>
                    )}
                </div>
                </div>
            </div>
            </Modal.Body>
    </Modal>


            <SlDrawer label={"New Brands"}
                open={showunknown}
                onSlRequestClose={handleRequestClose}
                noHeader={true}
                >

                <div>
                    {selectedBrands.length > 0 ? <div className="d-flex justify-end gap-3 my-2">
                            <SlButton variant="primary" size="small" onClick={()=>setMerge(true)} >Merge</SlButton>
                            <SlButton variant="primary" size="small" onClick={addBrands}>Add</SlButton>
                    </div> : null}
                    <div className="d-flex my-2 overflow-y-auto h-[80vh]">
                        <div className="w-1/2">
                            {unknownBrands?.map((brand) => {
                                return <div className="d-flex gap-2">
                                <input defaultChecked={completedBrands.includes(brand)} disabled={completedBrands.includes(brand)} type="checkbox" className={`form-check-input `} onChange={()=>{handleCheckboxChange(brand)}}></input>
                                <p className={`${completedBrands.includes(brand) ? "line-through" : ""}`}>{brand}</p>
                                </div>
                            })}
                        </div>
                        {merge && <div className="w-1/2">
                                <label className="form-label">Select Brand</label><br></br>
                                <Select options={mainBrand} onChange={(e)=>{setChoosedBrand(e.value)}}></Select>
                                <SlButton className="my-2" variant="success" size="small" onClick={MergeBrands}>Merge</SlButton>
                        </div>}
                    </div>
                    {completedBrands?.length === unknownBrands?.length && <div className="d-flex justify-end">
                        <SlButton variant="success" size="small" onClick={completeUnknownBrands}>Complete</SlButton>
                    </div>}
                </div>
            </SlDrawer>
       <SlDrawer
        open={showFilter}
        onSlRequestClose={handleRequestClose}
        placement="bottom"
        noHeader
        onSlAfterHide={()=>{}}
        style={{ "--size": "fit-content" }}
      >
                <div className="relative">
                    <h3 className="mb-3">Apply Filters</h3>
                    <hr></hr>
                    <div className="flex gap-4 flex-wrap w-full">
                        <div>
                            <Select
                                className='flex flex-wrap'
                                name='category'
                                size='medium'
                                placeholder='Select newspaper category'
                                value={selectedCategory}
                                onChange={(selected) => {
                                    setSelectedCategory(selected);
                                }}
                                options={newspaper_categories}
                                isMulti
                            />

                        </div>
                        <div className="w-full">
                            <Select
                                placeholder="Select Location"
                                name="source"
                                size="medium"
                                value={selectedLocation}
                                onChange={(selected) => {
                                    setSelectedLocation(selected || []); setData([]); setCurrentPage(0)
                                }}
                                options={[...locations]}
                                isMulti
                            />
                        </div>
                        <div  className="w-full">
                            <Select
                                className=''
                                placeholder="Select Newspaper"
                                name="source"
                                size="medium"
                                value={selectedNewspaper}
                                onChange={(selected) => {
                                    setSelectedNewspaper(selected || []); setData([]); setCurrentPage(0)
                                }}
                                options={[...newspaperData.filter(item => item.name !== 'Way2news').map(item => { return { label: item.name, value: item.name } })]}
                                isMulti
                            />
                        </div>

                        <div className="w-full">
                            <SlSelect
                                className='w-full'
                                placeholder="Select Ad Type"
                                name="adType"
                                size="medium"
                                value={adType}
                                onSlChange={(e) => { (setAdType(e.target.value)); setData([]); setCurrentPage(0) }}
                            >
                                <SlOption key={0} value={"Finite"}>Finite</SlOption>
                                <SlOption key={1} value={"Infinite"}>Infinite</SlOption>
                            </SlSelect>
                        </div>
                        <div className="w-full">
                            <SlSelect
                                placeholder="Select Brand Type"
                                name="adType"
                                size="medium"
                                value={selectedBrandType}
                                onSlChange={(e) => { (setSelectedBrandType(e.target.value)); setData([]); setCurrentPage(0) }}
                            >
                                <SlOption key={0} value={'0'}>All</SlOption>
                                <SlOption key={1} value={'1'}>National</SlOption>
                                <SlOption key={2} value={'2'}>Local</SlOption>
                                <SlOption key={3} value={'3'}>Metro</SlOption>
                            <SlOption key={4} value={'4'}>Local-TN</SlOption>
                            </SlSelect>
                        </div>

                        <SlInput className='w-full' size='medium' placeholder='Newspaper/Edition/Adv Name '
                            onSlInput={debounce(searchFilterOnChange, 500)}
                        >
                            <SlIcon library="lucide" name="search" slot="prefix"></SlIcon>
                        </SlInput>
                        <div className='border rounded-lg min-w-fit h-fit'>
                            <Datepicker
                                classNames="form-input"
                                value={dateRange}
                                primaryColor={"cyan"}
                                showShortcuts={true}
                                useRange={true} // Allow date range selection
                                configs={{
                                    shortcuts: {
                                        today: "today",
                                        yesterday: "yesterday",
                                        currentMonth: "currentMonth",
                                        pastMonth: "lastMonth",

                                    }
                                }}
                                onChange={handleDateRange}
                            />
                        </div>
                    </div>
                    <SlIcon
                        className="absolute top-1 right-1 text-2xl hover:text-red-600 cursor-pointer"
                        name="x-circle"
                        onClick={() => setShowFilter(false)}
                    ></SlIcon>
                </div>
      </SlDrawer>
      <SlDrawer
        label={"Summary"}
        open={showSummary} 
        onSlRequestClose={handleRequestClose}
        onSlAfterHide={() => {
          setShowSummary(false);
        }}
        style={{ "--size": "70vw" }}
      > 
         <BirdviewSummary locations={selectedLocation?.map(item => item.value)} ad_type={adType} category_ids = {selectedCategory.map((cat) => cat.value)} brand_type={+selectedBrandType} showSummary={showSummary} search={search} dateRange={dateRange} selectedNewspaper={selectedNewspaper} selectedCategory={selectedCategory} />
      </SlDrawer>
             <ReportBirdview open={showReport} setOpen={setShowReport} reportId={reportId} image_url={reportImageUrl}/>
      
        </>
    );

}

export default Birdview